import BlueToggle from "../../../../common/BlueToggle";
import BlueSlider from "../../../../common/BlueSlider/BlueSlider";
import BlueButton from "../../../../common/BlueButton/BlueButton";
import LoadingDisplay from "../../../../common/LoadingDisplay/LoadingDisplay";
import { useTranslation } from "react-i18next";
import "./chatNotificationDisplay.css";
import { useState } from "react";

const ChatNotifactionDisplay = ({ getSettings, updateUserSettings }) => {
    const { t } = useTranslation("settings");

    const currentSettings = getSettings();

    const [newInterval, setNewInterval] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const isActiveChatReminderInterval =
        currentSettings.chatReminderInterval !== 0 ? true : false;

    const updateUserSettingChatReminderInterval = async (value) => {
        setIsLoading(true);

        await updateUserSettings({ chatReminderInterval: value });

        setNewInterval(null);
        setIsLoading(false);
    };

    const displayIfActive = (
        <>
            <BlueSlider
                text={t("chatReminderComponentIntervalDisplayText", {
                    time: newInterval
                        ? newInterval
                        : currentSettings.chatReminderInterval,
                })}
                id="intervalDisplay"
                name="intervalDisplay"
                min={0} // 0 minutes
                max={180} // 3 hours in minutes
                defaultValue={currentSettings.chatReminderInterval}
                onChange={(e) => setNewInterval(parseInt(e.target.value))}
                step={1} // Step value of 1 minute
            />
            <br />
            <br />
            {newInterval ? (
                <BlueButton
                    text={t("settingsSaveButton")}
                    isDark={false}
                    onClick={() =>
                        updateUserSettingChatReminderInterval(
                            newInterval ? newInterval : 60,
                        )
                    }
                    isCenter={true}
                />
            ) : (
                <></>
            )}
        </>
    );

    const display = (
        <>
            <div className="chatNotificationDisplayDashboardToggleForDisplayText">
                <BlueToggle
                    title={t("chatReminderComponentTitle")}
                    onToggle={() => {
                        updateUserSettingChatReminderInterval(
                            isActiveChatReminderInterval ? 0 : 60,
                        );
                    }}
                    state={isActiveChatReminderInterval}
                />
            </div>
            <hr className="chatNotificationDisplayLineDashboard"></hr>
            <p className="settingsDescription">
                {t("chatReminderComponentDescription")}
            </p>

            {isActiveChatReminderInterval ? displayIfActive : <></>}
        </>
    );

    const loadingDisplay = (
        <div className="chatNotificationDisplayLoading">
            <LoadingDisplay invert={true} />
        </div>
    );

    return isLoading ? loadingDisplay : display;
};

export default ChatNotifactionDisplay;
